/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, reset } from 'redux-form';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getIconPath } from '@tcp/core/src/utils/utils';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel';
import {
  cardIconMapping,
  loading,
} from '@tcp/core/src/components/features/account/common/molecule/CardTile/views/CardTile.utils';
import TextBox from '@tcp/core/src/components/common/atoms/TextBox';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Button from '@tcp/core/src/components/common/atoms/Button';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import theme from '@tcp/core/styles/themes/TCP';
import styles from './PaymentOverviewTile.style';
import Anchor from '../../../../../../common/atoms/Anchor';
import Recaptcha from '../../../../../../common/molecules/recaptcha/recaptcha';
import createValidateMethod from '../../../../../../../utils/formValidation/createValidateMethod';
import getStandardConfig from '../../../../../../../utils/formValidation/validatorStandardConfig';
import internalEndpoints from '../../../internalEndpoints';
import PaymentOverviewTileNew from './PaymentOverviewTileNew.view';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblEdit,
} from '../../../../../../../utils/labels/globalActions.labels';
import AccountCommonLabels, {
  ACCOUNT_LABELS,
  GLOBAL_LABELS,
} from '../../../labels/AccountCommon.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblCreditCard,
  lblGiftCards,
} from '../../../../../../../utils/labels/globalGeneric.labels';

const { breakpoints } = theme;
const CREDIT_CARD_ICON_PATH = 'credit-card-icon';
class PaymentOverviewTile extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isTokenDirty: false,
      isCheckBalance: false,
      isRecaptchaVerified: false,
    };
    this.accountLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, AccountCommonLabels);
    this.globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, AccountCommonLabels);
    this.handleCheckBalanceClick = this.handleCheckBalanceClick.bind(this);
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(reset('giftCardCheckBalanceForm'));
  }

  /**
   * This will return true if card balance is requested.
   * @param {string} key - redux state key
   * @returns {boolean} true/false based on card requested state
   */
  getIfGiftCardBalanceRequested = (key) => {
    const { checkbalanceValueInfo } = this.props;
    return checkbalanceValueInfo && checkbalanceValueInfo.has(key);
  };

  /**
   * This will return Gift card balance
   * @param {string} key - redux state key
   * @returns {number} gift card balance
   */
  getGiftCardBalance = (key) => {
    const { checkbalanceValueInfo } = this.props;
    const balance = checkbalanceValueInfo && checkbalanceValueInfo.get(key);
    return typeof balance === 'number' ? balance.toString() : balance;
  };

  /**
   * This will handle recaptcha verification
   * @param {string} token - recaptcha token
   */
  handleRecaptchaVerify = (token) => {
    const { change } = this.props;
    change('recaptchaToken', token);
    const { onGetBalanceCard, giftCardList } = this.props;
    onGetBalanceCard({ formData: { recaptchaToken: token }, card: giftCardList });
    this.setState({ isTokenDirty: false, isRecaptchaVerified: true });
  };

  /**
   * This will handle recaptcha expiration and clear token from state
   */
  handleRecaptchaExpired = () => {
    const { change } = this.props;
    change('recaptchaToken', '');
  };

  /**
   * Set Recaptcha container reference
   */
  attachReCaptchaRef = (ref) => {
    this.recaptcha = ref;
  };

  /*
   * Set isCheckBalance to show Recaptcha verify and balance for Payment Redesign
   */
  handleCheckBalance = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      isCheckBalance: !prevState.isCheckBalance,
    }));
  };

  /**
   * This will render Venmo Card List
   */

  renderVenmoCardList = () => {
    const { venmoCardList } = this.props;
    return (
      <>
        {venmoCardList && venmoCardList.ccBrand && (
          <div className="heading venmo-tile">
            <BodyCopy component="div" className="elem-mt-LRG">
              <Row fullBleed>
                <Col
                  colSize={{
                    small: 6,
                    large: 12,
                    medium: 8,
                  }}
                  className="section-heading"
                >
                  <BodyCopy
                    component="div"
                    fontSize="fs14"
                    fontWeight="extrabold"
                    fontFamily="secondary"
                  >
                    {renderLabel(
                      this.accountLabels?.accountOverview?.lbl_overview_venmo,
                      'lbl_overview_venmo'
                    )}
                  </BodyCopy>
                  <Anchor
                    fontSizeVariation="large"
                    underline
                    anchorVariation="primary"
                    to={internalEndpoints.paymentPage.link}
                    asPath={internalEndpoints.paymentPage.path}
                  >
                    {renderLabel(
                      getLabelFromCopyOrFromTranslation(
                        `${GLOBAL_ACTIONS_LABELS}.${lblEdit}`,
                        GlobalActionsLabels
                      ),
                      'lbl_edit'
                    )}
                  </Anchor>
                </Col>
              </Row>
              <Row fullBleed className="elem-mb-XXL">
                <Col
                  colSize={{
                    small: 5,
                    large: 10,
                    medium: 7,
                  }}
                >
                  <BodyCopy component="div" className="cardDetailsWrapper">
                    <Image
                      className="venmoCardList_img"
                      src={getIconPath(cardIconMapping[venmoCardList.ccBrand])}
                      alt={venmoCardList.ccBrand || venmoCardList.ccType}
                      width={50}
                    />
                    <BodyCopy
                      fontSize="fs12"
                      fontFamily="secondary"
                      className="elem-mt-XS elem-ml-SM"
                      fontWeight="extrabold"
                    >
                      {venmoCardList.properties.venmoUserId}
                    </BodyCopy>
                  </BodyCopy>
                </Col>
              </Row>
            </BodyCopy>
          </div>
        )}
      </>
    );
  };

  handleCardType = (cardCCType) =>
    cardCCType?.toLowerCase().includes('place') ? `${cardCCType.toUpperCase()}_PJP` : cardCCType;

  /**
   * This will render redesigned credit card list
   */
  renderRedesignCreditCard = () => {
    const { creditCardDefault, useRouterNavigation } = this.props;

    const ccType = creditCardDefault?.ccType;
    const cardIcon = cardIconMapping[this.handleCardType(ccType)];
    return (
      <div>
        <BodyCopy component="div" className="credit-card-new">
          <BodyCopy component="div" className="tileWrapper">
            <BodyCopy component="div">
              <BodyCopy component="div" fontSize="fs16" fontWeight="bold" fontFamily="secondary">
                {getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_GENERIC_LABELS}.${lblCreditCard}`,
                  GlobalGenericLabels
                )}
              </BodyCopy>
              {!creditCardDefault?.ccType ? (
                <BodyCopy component="div" className="image-text-container">
                  <BodyCopy component="div" className="add-cards">
                    <Anchor
                      fontSizeVariation="large"
                      underline
                      anchorVariation="primary"
                      to="/account?id=add-credit-card"
                      asPath="/account/payment/add-credit-card"
                      className="add-credit-cards-link add-cards-link"
                    >
                      <Image
                        src={`${getIconPath('add-a-credit-card')}`}
                        alt={'Credit Card'}
                        className={CREDIT_CARD_ICON_PATH}
                      />
                    </Anchor>
                  </BodyCopy>
                  <BodyCopy component="div" className="add-cards-text">
                    {renderLabel(
                      this.globalLabels?.accountDrawer?.lbl_paymentOverviewTile_addCreditCard,
                      'lbl_paymentOverviewTile_addCreditCard'
                    )}
                  </BodyCopy>
                </BodyCopy>
              ) : (
                <BodyCopy component="div" className="credit-card-info">
                  <BodyCopy component="div" className="card-number-image">
                    <BodyCopy component="div">
                      <BodyCopy
                        component="div"
                        fontSize="fs14"
                        fontWeight="normal"
                        fontFamily="secondary"
                      >
                        {creditCardDefault.accountNo}
                      </BodyCopy>
                      <BodyCopy
                        component="div"
                        className="card-number"
                        fontSize="fs10"
                        fontWeight="normal"
                        fontFamily="secondary"
                      >
                        {renderLabel(
                          this.globalLabels?.accountDrawer?.lbl_paymentOverviewTile_cardNumber,
                          'lbl_paymentOverviewTile_cardNumber'
                        )}
                      </BodyCopy>
                    </BodyCopy>
                    <BodyCopy component="div">
                      <Image
                        className="elem-mr-XS"
                        src={getIconPath(cardIcon)}
                        alt={creditCardDefault.ccBrand || creditCardDefault.ccType}
                        width={50}
                      />
                    </BodyCopy>
                  </BodyCopy>
                  {creditCardDefault.ccType !== 'PLACE CARD' &&
                    creditCardDefault.ccType !== 'Placecard' && (
                      <BodyCopy component="div" className="expiry-card-number-container">
                        <BodyCopy
                          component="div"
                          fontSize="fs14"
                          fontWeight="normal"
                          fontFamily="secondary"
                        >
                          {creditCardDefault.expMonth}/{creditCardDefault.expYear}
                        </BodyCopy>
                        <BodyCopy
                          component="div"
                          className="card-expiry"
                          text
                          fontSize="fs10"
                          fontWeight="normal"
                          fontFamily="secondary"
                        >
                          {renderLabel(
                            this.accountLabels?.accountOverview?.lbl_overview_expires,
                            'lbl_overview_expires'
                          ).toUpperCase()}
                        </BodyCopy>
                      </BodyCopy>
                    )}
                </BodyCopy>
              )}
            </BodyCopy>
            {creditCardDefault && creditCardDefault.ccType && (
              <BodyCopy component="div">
                <Anchor
                  fontSizeVariation="large"
                  underline
                  anchorVariation="primary"
                  to={`/account?id=payment&subSection=edit-credit-card&creditCardId=${creditCardDefault.creditCardId}`}
                  asPath={`/account/payment/edit-credit-card/${creditCardDefault.creditCardId}`}
                  aria-label="Edit default credit card"
                  className="edit-link-card"
                  useRouterNavigation={useRouterNavigation}
                >
                  {renderLabel(
                    getLabelFromCopyOrFromTranslation(
                      `${GLOBAL_ACTIONS_LABELS}.${lblEdit}`,
                      GlobalActionsLabels
                    ),
                    'lbl_edit'
                  )}
                </Anchor>
              </BodyCopy>
            )}
          </BodyCopy>
        </BodyCopy>
      </div>
    );
  };

  /**
   * This will render credit card list
   */
  renderCreditCardList = () => {
    const { creditCardDefault } = this.props;
    const ccType = creditCardDefault?.ccType;
    const cardIcon = cardIconMapping[this.handleCardType(ccType)];

    return (
      <div className="heading">
        <div className="section-heading">
          <BodyCopy fontSize="fs14" fontWeight="extrabold" fontFamily="secondary">
            {renderLabel(
              this.accountLabels?.accountOverview?.lbl_overview_default_creditCard,
              'lbl_overview_default_creditCard'
            )}
          </BodyCopy>
          {creditCardDefault && creditCardDefault.ccType ? (
            <Anchor
              fontSizeVariation="large"
              underline
              anchorVariation="primary"
              to={internalEndpoints.paymentPage.link}
              asPath={internalEndpoints.paymentPage.path}
              aria-label="Edit default credit card"
            >
              {renderLabel(
                getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_ACTIONS_LABELS}.${lblEdit}`,
                  GlobalActionsLabels
                ),
                'lbl_edit'
              )}
            </Anchor>
          ) : (
            <Anchor
              fontSizeVariation="large"
              underline
              anchorVariation="primary"
              to={internalEndpoints.paymentPage.link}
              asPath={internalEndpoints.paymentPage.path}
            >
              {renderLabel(
                this.accountLabels?.accountOverview?.lbl_overview_addressBookAdd,
                'lbl_overview_addressBookAdd'
              )}
            </Anchor>
          )}
        </div>
        <Row fullBleed className="elem-mb-MED">
          <Col
            colSize={{
              small: 6,
              large: 12,
              medium: 8,
            }}
          >
            {creditCardDefault && creditCardDefault.ccType ? (
              <BodyCopy component="div" className="cardDetailsWrapper">
                <Image
                  className="elem-mr-XS"
                  src={getIconPath(cardIcon)}
                  alt={creditCardDefault.ccBrand || creditCardDefault.ccType}
                  width={50}
                />
                <BodyCopy component="div" className="cardDescriptionWrapper">
                  <BodyCopy fontSize="fs12" fontWeight="extrabold">
                    <BodyCopy component="span" className="cardEndingSpace" fontFamily="secondary">
                      {renderLabel(
                        this.accountLabels?.accountOverview?.lbl_overview_card_ending,
                        'lbl_overview_card_ending'
                      )}
                    </BodyCopy>
                    <BodyCopy component="span" fontFamily="secondary">
                      {creditCardDefault.accountNo.slice(-4)}
                    </BodyCopy>
                  </BodyCopy>
                  {creditCardDefault.ccType !== 'PLACE CARD' &&
                    creditCardDefault.ccType !== 'Placecard' && (
                      <BodyCopy fontSize="fs10">
                        <BodyCopy component="span" fontFamily="secondary">
                          {renderLabel(
                            this.accountLabels?.accountOverview?.lbl_overview_expires,
                            'lbl_overview_expires'
                          )}
                        </BodyCopy>
                        <BodyCopy component="span"> </BodyCopy>
                        <BodyCopy component="span" fontFamily="secondary">
                          {`0${creditCardDefault.expMonth.trim()}`.slice(-2)}
                        </BodyCopy>
                        <BodyCopy component="span" fontFamily="secondary">
                          /
                        </BodyCopy>
                        <BodyCopy component="span" fontFamily="secondary">
                          {creditCardDefault.expYear.slice(-2)}
                        </BodyCopy>
                      </BodyCopy>
                    )}
                </BodyCopy>
              </BodyCopy>
            ) : (
              <BodyCopy fontSize="fs14" fontFamily="secondary">
                {renderLabel(
                  this.accountLabels?.accountOverview?.lbl_overview_add_creditCard,
                  'lbl_overview_add_creditCard'
                )}
              </BodyCopy>
            )}
          </Col>
        </Row>
      </div>
    );
  };

  renderRedesignRecaptcha = (balance, isRecapchaEnabled) => {
    if (!balance && isRecapchaEnabled) {
      return (
        <>
          <Recaptcha
            ref={this.attachReCaptchaRef}
            onloadCallback={this.handleRecaptchaOnload}
            verifyCallback={this.handleRecaptchaVerify}
            expiredCallback={this.handleRecaptchaExpired}
          />
          <Field
            component={TextBox}
            title=""
            type="hidden"
            placeholder="recaptcha value"
            name="recaptchaToken"
            id="recaptchaToken"
            data-locator="gift-card-recaptchcb"
          />
        </>
      );
    }

    return null;
  };

  /*
   * This will render add gift or credit card
   */
  renderAddGiftOrCreditCard = () => {
    const { giftCardList, creditCardDefault } = this.props;

    return giftCardList?.ccType || creditCardDefault?.ccType ? (
      <div>
        <BodyCopy component="div" className="gift-card-new">
          <BodyCopy component="div" className="tileWrapper">
            <BodyCopy component="div">
              <BodyCopy component="div" fontSize="fs16" fontWeight="bold" fontFamily="secondary">
                {renderLabel(
                  this.globalLabels?.accountDrawer?.lbl_paymentOverviewTile_addCard,
                  'lbl_paymentOverviewTile_addCard'
                )}
              </BodyCopy>
              <BodyCopy component="div" className="image-text-container">
                <BodyCopy component="div" className="add-cards">
                  <Anchor
                    fontSizeVariation="large"
                    underline
                    anchorVariation="primary"
                    to={internalEndpoints.paymentPage.link}
                    asPath={internalEndpoints.paymentPage.path}
                    className="add-cards-link"
                  >
                    <Image
                      src={`${getIconPath('add-a-credit-card')}`}
                      alt={'Add a Credit or Gift Card'}
                      className="gift-card-icon"
                    />
                  </Anchor>
                </BodyCopy>
                <BodyCopy component="div" className="add-cards-text">
                  {renderLabel(
                    this.globalLabels?.accountDrawer?.lbl_paymentOverviewTile_addCreditOrGift,
                    'lbl_paymentOverviewTile_addCreditOrGift'
                  )}
                </BodyCopy>
              </BodyCopy>
            </BodyCopy>
          </BodyCopy>
        </BodyCopy>
      </div>
    ) : null;
  };

  /**
   * This will render redesigned Gift card list
   */
  renderRedesignGiftCard = () => {
    const { giftCardList, isRecapchaEnabled, handleSubmit } = this.props;
    const isGiftCardBalanceRequested = this.getIfGiftCardBalanceRequested(
      giftCardList?.creditCardId
    );

    const balance =
      giftCardList && giftCardList.ccType && this.getGiftCardBalance(giftCardList?.creditCardId);
    return (
      <div>
        <BodyCopy component="div" className="gift-card-new">
          <BodyCopy component="div" className="tileWrapper">
            <BodyCopy component="div">
              <BodyCopy component="div" fontSize="fs16" fontWeight="bold" fontFamily="secondary">
                {getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_GENERIC_LABELS}.${lblGiftCards}`,
                  GlobalGenericLabels
                )}
              </BodyCopy>
              {!giftCardList?.ccType ? (
                <BodyCopy component="div" className="image-text-container">
                  <BodyCopy component="div" className="add-cards">
                    <Anchor
                      fontSizeVariation="large"
                      underline
                      anchorVariation="primary"
                      to="/account?id=payment&subSection=add-gift-card"
                      asPath="/account/payment/add-gift-card"
                      className="add-gift-cards-link add-cards-link"
                    >
                      <Image
                        src={`${getIconPath('add-a-gift-card')}`}
                        alt={'Gift Card'}
                        className="gift-card-icon"
                      />
                    </Anchor>
                  </BodyCopy>
                  <BodyCopy component="div" className="add-cards-text">
                    {renderLabel(
                      this.globalLabels?.accountDrawer?.lbl_paymentOverviewTile_addGiftCard,
                      'lbl_paymentOverviewTile_addGiftCard'
                    )}
                  </BodyCopy>
                </BodyCopy>
              ) : (
                <BodyCopy component="div">
                  <BodyCopy component="div">
                    <BodyCopy component="div" className="card-number-image">
                      <BodyCopy component="div" className="gift-card-account-info">
                        <BodyCopy
                          component="div"
                          fontSize="fs14"
                          fontWeight="normal"
                          fontFamily="secondary"
                        >
                          {giftCardList.accountNo}
                        </BodyCopy>
                        <BodyCopy
                          component="div"
                          className="card-number"
                          fontSize="fs10"
                          fontWeight="normal"
                          fontFamily="secondary"
                        >
                          {renderLabel(
                            this.globalLabels?.accountDrawer?.lbl_paymentOverviewTile_cardNumber,
                            'lbl_paymentOverviewTile_cardNumber'
                          )}
                        </BodyCopy>
                        {this.state.isCheckBalance && (
                          <BodyCopy component="div" className="card-number">
                            {balance && (
                              <BodyCopy component="div" className="gift-balance-container">
                                <BodyCopy
                                  component="div"
                                  fontSize="fs14"
                                  fontFamily="secondary"
                                  fontWeight="normal"
                                  className=""
                                >
                                  {`$${balance}`}
                                </BodyCopy>
                                <BodyCopy
                                  component="div"
                                  fontSize="fs10"
                                  fontWeight="normal"
                                  fontFamily="secondary"
                                  className="remaining-balance-text"
                                >
                                  {renderLabel(
                                    this.accountLabels?.accountOverview
                                      ?.lbl_overview_remaining_balance,
                                    'lbl_overview_remaining_balance'
                                  )}
                                </BodyCopy>
                              </BodyCopy>
                            )}
                            <form
                              name="giftcardBalance_redesign"
                              onSubmit={handleSubmit}
                              autoComplete="off"
                              noValidate
                            >
                              <div className="giftcardTile__row-redesign">
                                {this.renderRedesignRecaptcha(balance, isRecapchaEnabled)}
                                {this.state.isRecaptchaVerified && (
                                  <BodyCopy
                                    component="div"
                                    className="balance-loading"
                                    fontSize="fs12"
                                  >
                                    {loading(isGiftCardBalanceRequested, balance)}
                                  </BodyCopy>
                                )}
                              </div>
                            </form>
                          </BodyCopy>
                        )}
                      </BodyCopy>
                      <BodyCopy component="div">
                        <Image
                          className="elem-mr-XS"
                          src={getIconPath(cardIconMapping[giftCardList.ccBrand])}
                          alt={giftCardList.ccBrand || giftCardList.ccType}
                          width={50}
                        />
                      </BodyCopy>
                    </BodyCopy>
                  </BodyCopy>
                </BodyCopy>
              )}
            </BodyCopy>
            {giftCardList && giftCardList.ccType && (
              <BodyCopy component="div" className="balance-action-container">
                <BodyCopy component="div">
                  {!this.state.isCheckBalance && (
                    <Button
                      onClick={this.handleCheckBalance}
                      type="button"
                      data-locator="gift-card-checkbalance-btn"
                      link
                      underline
                      className="check-balance"
                    >
                      {renderLabel(
                        this.accountLabels?.accountOverview?.lbl_overview_check_balance,
                        'lbl_overview_check_balance'
                      )}
                    </Button>
                  )}
                </BodyCopy>
                <BodyCopy component="div">
                  <Anchor
                    underline
                    to={internalEndpoints.paymentPage.link}
                    asPath={internalEndpoints.paymentPage.path}
                    aria-label="Edit gift card"
                    className="edit-link-card"
                  >
                    {renderLabel(
                      getLabelFromCopyOrFromTranslation(
                        `${GLOBAL_ACTIONS_LABELS}.${lblEdit}`,
                        GlobalActionsLabels
                      ),
                      'lbl_edit'
                    )}{' '}
                  </Anchor>
                </BodyCopy>
              </BodyCopy>
            )}
          </BodyCopy>
        </BodyCopy>
      </div>
    );
  };

  /**
   * Handle Button click for check balance
   * @param {object} e - Button event
   */
  handleCheckBalanceClick = (e) => {
    const { isTokenDirty } = this.state;
    const { change, handleSubmit, giftCardList } = this.props;
    e.preventDefault();
    if (isTokenDirty) {
      change('recaptchaToken', '');
      this.setState({
        isTokenDirty: false,
      });
      return;
    }

    /**
     * Submit Gift Card Form
     * @param {object} formData - Gift Card form object
     */
    handleSubmit((formData) => {
      const { onGetBalanceCard } = this.props;
      onGetBalanceCard({ formData, card: giftCardList });
    })();
  };

  render() {
    const { className } = this.props;
    const CAROUSEL_OPTIONS = {
      autoplay: false,
      arrows: false,
      autoplaySpeed: 4000,
      infinite: false,
      initialSlide: 0,
      fade: false,
      speed: 300,
      dots: true,
      dotsClass: 'slick-dots',
      focusOnSelect: true,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: parseInt(breakpoints.medium, 10) - 1,
          settings: {
            autoplay: false,
            arrows: false,
            infinite: false,
            swipe: true,
            slidesToShow: 1.5,
            initialSlide: 0,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: parseInt(breakpoints.large, 10) - 1,
          settings: {
            autoplay: false,
            arrows: false,
            infinite: false,
            initialSlide: 0,
            slidesToShow: 2.5,
            slidesToScroll: 2,
          },
        },
      ],
    };

    return (
      <PaymentOverviewTileNew>
        <BodyCopy
          component="div"
          className={`${className} payment_carousel account-payment-carousel-new`}
        >
          <Carousel
            options={CAROUSEL_OPTIONS}
            carouselConfig={{
              customArrowLeft: null,
              customArrowRight: null,
              arrow: 'small',
              type: 'light',
            }}
            carouselTheme="dark"
          >
            {[
              this.renderRedesignCreditCard(),
              this.renderRedesignGiftCard(),
              this.renderAddGiftOrCreditCard(),
            ]}
          </Carousel>
        </BodyCopy>
      </PaymentOverviewTileNew>
    );
  }
}

const validateMethod = createValidateMethod(getStandardConfig(['recaptchaToken']));

PaymentOverviewTile.propTypes = {
  className: PropTypes.string,
  creditCardDefault: PropTypes.shape({}),
  giftCardList: PropTypes.shape({}),
  venmoCardList: PropTypes.shape({}),
  dispatch: PropTypes.func.isRequired,
  checkbalanceValueInfo: PropTypes.string.isRequired,
  onGetBalanceCard: PropTypes.func.isRequired,
  handleSubmit: PropTypes.string.isRequired,
  change: PropTypes.string.isRequired,
  isRecapchaEnabled: PropTypes.bool.isRequired,
  useRouterNavigation: PropTypes.bool,
};

PaymentOverviewTile.defaultProps = {
  className: '',
  creditCardDefault: {},
  giftCardList: {},
  venmoCardList: {},
  useRouterNavigation: false,
};

export default reduxForm({
  form: 'giftCardCheckBalanceForm',
  destroyOnUnmount: false,
  enableReinitialize: true,
  ...validateMethod,
})(withStyles(PaymentOverviewTile, styles));
export { PaymentOverviewTile as PaymentOverviewTileVanilla };
